import { render } from "./ItemId.vue?vue&type=template&id=670bc774&ts=true"
import script from "./ItemId.vue?vue&type=script&lang=ts"
export * from "./ItemId.vue?vue&type=script&lang=ts"

import "./ItemId.vue?vue&type=style&index=0&id=670bc774&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__